var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.5772 30.0476L42.6625 67.9623L22.7689 48.0688C21.8796 47.1326 20.3817 47.1092 19.469 48.022C18.5328 48.9113 18.5094 50.4092 19.4221 51.322C19.4221 51.322 19.4456 51.3454 19.469 51.3688L41.0242 72.924C41.9369 73.8368 43.4114 73.8368 44.3242 72.924L83.8771 33.371C84.7899 32.4348 84.7665 30.9604 83.8303 30.071C82.9176 29.1817 81.4665 29.1817 80.5538 30.071L80.5772 30.0476Z",
    fill: "#FF669B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4891 0.000300146C23.0531 0.000300146 0 23.0534 0 51.4894C0 65.134 5.42976 78.2403 15.0723 87.9063C35.0828 108.104 67.6848 108.244 87.8825 88.2339C108.08 68.2234 108.221 35.6214 88.2102 15.4236C88.0932 15.3066 87.9996 15.213 87.8825 15.096C78.2634 5.38325 65.1571 -0.0465081 51.4891 0.000300146ZM84.5826 84.5829C66.3507 102.908 36.6977 102.979 18.3957 84.7233C0.0702129 66.4915 0 36.8618 18.2318 18.5364C18.2786 18.4896 18.3254 18.4428 18.3722 18.396C36.6275 0.0705131 66.2571 0.000300203 84.5826 18.2555C102.908 36.4874 102.978 66.1404 84.723 84.4424C84.6762 84.4893 84.6294 84.5361 84.5826 84.5829Z",
    fill: "#FF669B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTick);
export default __webpack_public_path__ + "static/media/SuccessTick.7f8c38b83ac5318068082f36ac1421d8.svg";
export { ForwardRef as ReactComponent };